export const BASIC_VALIDATION_FAILED =
    'One or more fields contain incorrect values. Please, review the entered parameters and try again.';

export const VALIDATION_FAILED =
    'One or more required parameters contain incorrect values or at least one standard data set/platform feature' +
    ' has not been selected';

export const NO_PRIMARY_ATM = 'NO_PRIMARY_ATM';
export const NO_PRIMARY_ATM_MESSAGE = 'Primary account team member is required';

export const NO_PRIMARY_ME_IN_TEAM = 'NO_ME_IN_TEAM';
export const NO_PRIMARY_ME_IN_TEAM_MESSAGE =
    'You cannot create the account because you are not a member of the Account team.';
